import { Link } from 'react-router-dom';
import { articles, getFeaturedArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featured = getFeaturedArticles();
  const mainArticle = featured[0];
  const sideArticles = featured.slice(1, 4);

  return (
    <section className="relative w-full min-h-[620px] flex items-end pb-6">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20editorial%20newsroom%20with%20warm%20cinematic%20lighting%2C%20vintage%20journalism%20aesthetic%2C%20breaking%20news%20vibe%2C%20spotlight%20on%20empty%20desk%20with%20scattered%20documents%2C%20mysterious%20atmosphere%2C%20amber%20and%20deep%20shadow%20tones&width=1920&height=800&seq=home-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/70"></div>
      </div>

      <div className="relative w-full px-6 md:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            {mainArticle && (
              <Link to={`/article/${mainArticle.slug}`} className="group block">
                <span className="inline-block px-3 py-1 text-xs font-bold rounded-md bg-primary-500 text-white mb-4">
                  头条曝光
                </span>
                <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight line-clamp-3 group-hover:text-primary-300 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {mainArticle.title}
                </h1>
                <p className="text-white/70 mt-4 text-base md:text-lg line-clamp-2 max-w-xl">
                  {mainArticle.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-5 text-sm text-white/50">
                  <span className="whitespace-nowrap">{mainArticle.publishedAt}</span>
                  <span className="whitespace-nowrap">{mainArticle.readCount.toLocaleString()} 阅读</span>
                </div>
              </Link>
            )}
          </div>

          <div className="hidden lg:flex flex-col gap-3">
            {sideArticles.map((article, i) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group flex items-center gap-3 p-3 rounded-lg bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all"
              >
                <span className="text-2xl font-bold text-white/30 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                  {String(i + 2).padStart(2, '0')}
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-bold text-white line-clamp-2 group-hover:text-primary-300 transition-colors">
                    {article.title}
                  </h3>
                  <span className="text-xs text-white/40 mt-1 block">{article.publishedAt}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}